import { useQuery, gql } from "@apollo/client";
import { Practice } from "../../@lib/types";
import { useLanguageTranslator } from "../../components";

type PracticesCollectionData = {
  practices: Practice[];
};

const fetchPoliciesDocuments = gql`
  query (
    $limit: Int
    $countryId: Int
    $themeId: Int
    $startYear: Int
    $endYear: Int
    $geographicalAreaId: Int
  ) {
    policyDocuments(
      limit: $limit
      countryId: $countryId
      themeId: $themeId
      startYear: $startYear
      endYear: $endYear
      geographicalAreaId: $geographicalAreaId
    ) {
      collection {
        createdAt
        filename
        id
        path
      }
      metadata {
        currentPage
        limitValue
        totalCount
        totalPages
      }
    }
  }
`;

const usePoliciesDocumentsCall = ({ variables }: any) => {
  const { data, loading } = useQuery<PracticesCollectionData>(
    fetchPoliciesDocuments,
    {
      fetchPolicy: "cache-and-network",
      variables: variables,
    }
  ) as any;

  return {
    policyDocuments: data?.policyDocuments?.collection,
    loading,
  };
};

export { usePoliciesDocumentsCall };
